import { type MutationError, trpc } from '@/shared/api';

interface UseDeleteDraftOptions {
  readonly onSuccess?: () => void;
}

interface UseDeleteDraftResult {
  readonly deleteDraft: (id: string) => void;
  readonly isPending: boolean;
  readonly error: MutationError | null;
  /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
  readonly reset: () => void;
}

/** 등록 중(DRAFT) 상품 삭제 — 공개 이력이 있는 상품은 서버가 거부한다. */
export const useDeleteDraft = ({ onSuccess }: UseDeleteDraftOptions = {}): UseDeleteDraftResult => {
  const mutation = trpc.productManagement.products.deleteDraft.useMutation({ onSuccess });

  return {
    deleteDraft: (id) => mutation.mutate({ id }),
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
};
